import type { MessageSchema } from '@/assets/i18n/index.ts'

export const it: MessageSchema = {
  cancel: 'Annulla',
  confirm: 'Conferma',
  search: 'Cerca',
  clear: 'Pulisci',
  noData: 'Nessun dato disponibile',
  save: 'Salva',
  run: 'Esegui',
  add: 'Aggiungi',
  back: 'Indietro',
  delete: 'Elimina',
  update: 'Aggiorna',
  next: 'Avanti',
  options: 'Opzioni',
  other: 'Altro',
  choose: 'Scegli',
  edit: 'Modifica',
  elementSelected: 'elemento selezionato. | elementi selezionati.',
  details: 'Dettagli',
  import: 'Importa',
  id: 'Id',
  page: 'Pagina',
  loadOthers: 'Carica altri',
  previous: 'Precedente',
  filters: 'Filtri',

  column: {
    archiveNumber: 'Posizione archivio',
    authority: 'Autorità',
    color: 'Colore',
    createdAt: 'Data creazione',
    date: 'Data',
    description: 'Descrizione',
    displayName: 'Nome',
    documents: 'Documenti',
    email: 'E-mail',
    externalId: 'Id pratica',
    filename: 'Nome file',
    icon: 'Icona',
    id: 'Id',
    index: 'Indice',
    judicialData: 'Riferimenti giudiziali',
    key: 'Chiave',
    pec: 'PEC',
    permissions: 'Permessi',
    phase: 'Fase',
    practiceName: 'Nome pratica',
    response: 'Risposta',
    roles: 'Ruoli',
    sentAt: 'Data invio',
    site: 'Foro',
    source: 'Sorgente',
    status: 'Stato',
    telephone: 'Telefono',
    type: 'Tipo',
    user: 'Utente',
    users: 'Utenti',
    value: 'Valore',
    values: 'Valori',
    vatCode: 'P. IVA',
    visible: 'Visibile',
    writeOnly: 'Sensibile',
  },

  toast: {
    success: 'Successo',
    error: 'Errore',
    warn: 'Attenzione',
    genericSuccess: 'Operazione completata con successo!',
    genericError: 'Oops, si è verificato un errore!',
    created: 'Dati salvati con successo!',
    updated: 'Dati aggiornati con successo!',
    removed: 'Dati rimossi con successo!',
  },

  duration: {
    days: 'giorno | giorni',
    hours: 'ora | ore',
    minutes: 'minuto | minuti',
    seconds: 'secondo | secondi',
    Days: 'giorno | giorni',
    Hours: 'ora | ore',
    Minutes: 'minuto | minuti',
    Seconds: 'secondo | secondi',
    Weeks: 'settimana | settimane',
    Months: 'mese | mesi',
    Years: 'anno | anni',
  },

  login: {
    header: 'Benvenuto!',
    tenant: 'Tenant',
    username: 'Username',
    password: 'Password',
    button: 'Entra',
    accessDenied: 'Login fallito. Controlla i tuoi dati e riprova.',
  },

  logout: {
    button: 'Esci',
    dialogMessage: 'Sei sicuro di voler uscire?',
    header: 'Logout',
    confirm: 'Esci',
  },

  validations: {
    email: 'Questo campo deve essere un indirizzo e-mail valido',
    generalRoleNumber: 'Questo campo deve essere un numero di ruolo generale nel formato N/AAAA o N-N/AAAA',
    identifier: 'Questo campo può contenere solo caratteri alfanumerici (a-z, A-Z, 0-9) e underscores (_)',
    archiveNumber:
      'Questo campo può contenere solo caratteri alfanumerici (a-z, A-Z, 0-9), spazi, trattini (-) e underscores (_)',
    minLength: 'Questo campo deve essere lungo almeno {min} caratteri',
    notIn: 'Questo campo non può essere un valore tra: {values}',
    required: 'Questo campo è richiesto',
    telephone: 'Questo campo deve essere un numero di telefono valido',
    fiscalCode: 'Questo campo deve essere un codice fiscale valido',
    vatCode: 'Questo campo deve essere una partita IVA valida',
    phaseTooltip: 'Seleziona prima il tipo di pratica',
    url: 'Questo campo deve essere una URL valido, avente prefisso https://',
    courtOfficeCode: 'Questo campo deve essere un codice ufficio valido, composto da 10 o 11 cifre',
    maxFileSize: 'La dimensione del file non deve superare {size} MB',
  },

  sidebar: {
    apb: 'APB',
    apbPractices: 'Pratiche APB',
    apbProcessedEmails: 'E-mail APB',
    case: 'Posizione',
    caseDetailsEvents: 'Eventi',
    caseDetailsRecords: 'Schede',
    caseDetailsSubjectRecords: 'Schede',
    caseDetailsSubjects: 'Soggetti',
    caseRecordTypes: 'Tipi schede posizione',
    cases: 'Posizioni',
    courts: 'Tribunali',
    deadlineBadges: 'Badge scadenze',
    deadlines: 'Scadenze',
    details: 'Dettaglio',
    duplicateMerge: 'Riunione duplicati',
    edit: 'Modifica',
    emailCampaigns: 'Campagne e-mail',
    home: 'Home',
    massiveEmailEvents: 'Eventi',
    massiveEmailMetadata: 'Metadata',
    massiveEmails: 'E-mail massive',
    massiveEmailTypes: 'Tipi e-mail massive',
    massiveImports: 'Import massivi',
    new_f: 'Nuova',
    new_m: 'Nuovo',
    parties: 'Parti',
    pct: 'Polisweb',
    pctDeposits: 'Depositi telematici',
    pctEvents: 'Eventi Polisweb',
    personLinks: 'Collegamenti persone',
    persons: 'Persone',
    portfolios: 'Portafogli',
    practiceDetailsDeadlines: 'Scadenze',
    practiceDetailsEvents: 'Eventi',
    practiceDetailsPctEvents: 'Eventi Polisweb',
    practiceDetailsRecords: 'Schede',
    practiceDetailsSubjectRecords: 'Schede',
    practiceDetailsSubjects: 'Soggetti',
    practicePhases: 'Fasi pratica',
    practices: 'Pratiche',
    practiceTypeAssignmentRoles: 'Ruoli assegnamenti',
    practiceTypeDeadlineTypes: 'Tipi scadenze',
    practiceTypeRecordTools: 'Tools',
    practiceTypeRecordTypes: 'Tipi di schede',
    practiceTypes: 'Tipi di pratica',
    preview: 'Anteprima',
    profile: 'Profilo',
    receivers: 'Destinatari',
    recordTypes: 'Tipi schede',
    relations: 'Relazioni',
    reports: 'Report',
    responses: 'Risposte',
    roles: 'Ruoli',
    settings: 'Configurazioni',
    specificFields: 'Campi specifici',
    subjectTypes: 'Tipi soggetti',
    tasks: 'Incarichi',
    taskTypes: 'Tipi di incarico',
    support: 'Supporto',
    systemManagement: 'Gestione sistema',
    toolRuns: 'Tools',
    unauthorized: 'Non autorizzato',
    userManagement: 'Gestione utenti',
    users: 'Utenti',
  },

  unauthorized: {
    title: 'Non autorizzato',
    body: 'Non disponi dei permessi necessari per visualizzare questa pagina!',
    solution: 'Contatta il tuo amministratore.',
  },

  home: {
    greetings: {
      morning: 'Buongiorno {name}!',
      afternoon: 'Buon pomeriggio {name}!',
      evening: 'Buona sera {name}!',
      night: 'Buona notte {name}!',
    },
    recentPractices: 'Pratiche recenti',
    recentToolRuns: 'Esecuzioni tool recenti',
    noRecentPractices: 'Non hai visualizzato alcuna pratica di recente',
    noRecentToolRuns: 'Nessuna esecuzione tool da mostrare',
    pendingTasks: 'Incarichi da completare',
    noPendingTasks: 'Non hai incarichi da completare',
    seeAll: 'Visualizza tutti',
    deadlines: 'Scadenze',
    noDeadlines: 'Non hai scadenze da adempiere',
    deadlineGroups: {
      expired: 'Scadute',
      thisWeek: 'Questa settimana',
      thisMonth: 'Questo mese',
      future: 'Future',
    },
    homepageSettings: {
      title: 'Impostazioni homepage',
      practices: 'Pratiche',
      deadlines: 'Scadenze',
      toolRuns: 'Esecuzioni tool',
      tasks: 'Incarichi',
    },
  },

  emailCampaigns: {
    title: 'Campagne e-mail',
    id: 'Id',
    name: 'Nome',
    createdAt: 'Data creazione',
    details: 'Dettagli',
  },

  emailCampaignResponses: {
    id: 'Id',
    externalId: 'Id pratica',
    practiceName: 'Nome pratica',
    email: 'E-mail',
    sentAt: 'Data invio',
    downloadResponses: 'Scarica risposte',
  },

  users: {
    title: 'Utenti',
    id: 'Id',
    displayName: 'Nome',
    email: 'E-mail',
    roles: 'Ruoli',
    add: 'Crea nuovo utente',
    edit: 'Modifica utente',
    firstLoginPsw: 'Password primo accesso',
    resetPassword: 'Reset password',
    tooltipFirstLoginPsw: [
      'La password inserita sarà valida solo per il primo accesso.',
      "Dopo il primo login, all'utente verrà richiesto di cambiarla e scegliere una nuova password personale.",
    ].join('\n'),
    disabled: 'Disabilitato',
    disable: 'Disabilita',
    disableHeader: 'Disabilita Utente',
    disableConfirm: "Sei sicuro di voler disabilitare {name}? L'utente non potrà più accedere al sistema.",
    enable: 'Abilita',
    enabled: 'Abilitato',
    enableConfirm: 'Sei sicuro di voler abilitare {name}?',
    enableHeader: 'Abilita Utente',
    disabledInfo:
      "Questo utente è stato disabilitato e non può più accedere all'applicazione. Per riabilitarlo clicca il pulsante 'Abilita'.",
  },

  roles: {
    title: 'Ruoli',
    table: {
      edit: 'Modifica',
      id: 'Id',
      name: 'Nome',
      permissions: 'Permessi',
      users: 'Utenti',
    },
    stepper: {
      add: 'Crea nuovo ruolo',
      edit: 'Modifica ruolo',
      stepName: 'Nome',
      roleNameStepper: {
        name: 'Nome',
        description: 'Descrizione',
        nameHelp: 'Il nome deve essere lungo almeno 3 caratteri.',
      },
      stepPermissions: 'Permessi',
      stepUsers: 'Utenti',
    },
  },

  courts: {
    title: 'Tribunali',
    id: 'Id',
    authority: 'Autorità',
    site: 'Foro',
    officeCode: 'Codice ufficio (PCT)',
    add: 'Crea nuovo tribunale',
    edit: 'Modifica tribunale',
    editDialog: {
      header: 'Attenzione!',
      message: 'Rinominando un tribunale la modifica impatterà tutte le pratiche ad esso collegate.',
    },
    mergeDialog: {
      title: 'Riunione duplicati',
      description:
        'Stai per riunire {courtName} con quello che selezionerai dalla lista sottostante. Questo sarà eliminato e tutte le sue occorrenze nelle pratiche saranno rimpiazzate con il nuovo tribunale.',
      destination: 'Tribunale di destinazione',
      confirmMessage: 'Sei sicuro di voler procedere? Questa azione è irreversibile.',
      button: 'Riunione duplicati',
    },
  },

  practiceTypes: {
    title: 'Tipi di pratica',
    id: 'Id',
    displayName: 'Nome',
    icon: 'Icona',
    judicial: 'Giudiziale',
    externalIdLabel: 'Etichetta ID esterno',
    add: 'Crea nuovo tipo di pratica',
    edit: 'Modifica tipo di pratica',
    details: 'Tipo di pratica - {name}',
    defaultPhase: 'Fase predefinita',
    defaultPhaseName: 'Nome fase predefinita',
    defaultPhaseColor: 'Colore fase predefinita',
    phases: {
      title: 'Fasi pratica',
      id: 'Id',
      displayName: 'Nome',
      color: 'Colore',
      visible: 'Visibile',
      default: 'Default',
      archiving: 'Archiviazione',
      add: 'Crea nuova fase pratica',
      edit: 'Modifica fase pratica',
      noDefaultLeft: 'Non è possibile lasciare un tipo di pratica senza una fase di default',
      noHiddenDefault: 'La fase di default deve essere visibile',
    },
    recordTools: {
      title: 'Tools',
      recordTool: 'Tool',
      add: 'Aggiungi nuovo tool',
      removeHeader: 'Rimozione',
      removeMessage: 'Sei sicuro di voler rimuovere il tool "{toolName}" dal tipo di pratica?',
      autoRun: 'Esecuzione automatica',
      autoRunInfo:
        "Se l'esecuzione automatica è impostata il tool verrà eseguito ad ogni modifica di una scheda della pratica o di un soggetto",
    },
    assignmentRoles: {
      title: 'Ruoli assegnamento',
      assignmentRole: 'Ruolo assegnamento',
      add: 'Aggiungi nuovo ruolo assegnamento',
      removeHeader: 'Rimozione',
      removeMessage: 'Sei sicuro di voler rimuovere il ruolo "{roleName}" dal tipo di pratica?',
    },
    deadlineTypes: {
      title: 'Tipi scadenze',
      displayName: 'Nome',
      icon: 'Icona',
      color: 'Colore',
      category: 'Categoria',
      visible: 'Visibile',
      targetPhase: 'Fase destinazione',
      add: 'Crea nuovo tipo di scadenza',
      edit: 'Modifica tipo di scadenza',
    },
    recordTypesTitle: 'Schede',
  },

  specificFields: {
    key: 'Chiave',
    keyTooltip: "Questo è l'identificatore univoco del campo all'interno del sistema e nei vari export",
    displayName: 'Nome',
    type: 'Tipo',
    color: 'Colore',
    visible: 'Visibile',
    values: 'Valori',
    add: 'Crea nuovo campo',
    edit: 'Modifica campo',
    sort: 'Riordina',
    hidden: 'Nascosto',
    starred: 'In evidenza',
    starredTooltip: 'I campi in evidenza vengono mostrati in una sezione dedicata nei dettagli della pratica',
    types: {
      string: 'Testuale',
      number: 'Decimale',
      int: 'Intero',
      eur_currency: 'Valuta (€)',
      boolean: 'Spunta',
      enum: 'Selezione multipla',
      date: 'Data',
      datetime: 'Data e ora',
    },
  },

  settings: {
    title: 'Configurazioni',
    name: 'Nome',
    value: 'Valore',
    writeOnly: 'Sensibile',
    add: 'Crea nuova configurazione',
    edit: 'Modifica configurazione',
  },

  practices: {
    title: 'Pratiche',
    archiveNumber: 'Posizione archivio',
    status: 'Stato',
    judicialData: 'Riferimenti giudiziali',
    createdAt: 'Data creazione',
    displayName: 'Nome',
    generalRoleNumber: 'Numero di ruolo generale',
    parent: 'Pratica genitore',
    mergedInto: 'Pratica riunita',
    court: 'Tribunale',
    registry: 'Registro',
    searchString: 'Ricerca',
    practiceType: 'Tipo pratica',
    practicePhase: 'Fase pratica',
    type: 'Tipo',
    phase: 'Fase',
    externalId: 'ID esterno',
    filters: {
      title: 'Filtri pratica',
      searchString: 'Nome o posizione archivio',
      typePhase: 'Tipo e fase pratica',
      externalId: 'ID esterno',
      judicialData: 'Riferimenti giudiziali',
      assignments: 'Assegnamenti',
      unassigned: 'Non assegnata',
      mine: 'Assegnata a me',
      archived: 'Archiviata',
    },
    add: 'Crea nuova pratica',
    steps: {
      parent: 'Pratica genitore',
      practiceData: 'Dati pratica',
      cloneSubjects: 'Soggetti da clonare',
      summary: 'Riepilogo',
    },
    cloneSubjects: 'Copia soggetti',
    addSummary: {
      details: 'Dettagli',
      assignments: 'Utenti assegnati',
      subjects: 'Soggetti copiati',
    },
  },

  portfolio: {
    title: 'Portafogli',
    add: 'Crea nuovo portafoglio',
    edit: 'Modifica portafoglio',
    displayName: 'Nome',
    caseCount: 'Posizioni',
    remove: {
      button: 'Elimina',
      title: 'Conferma rimozione',
      message: 'Sei sicuro di voler eliminare "{displayName}"?',
    },
  },

  cases: {
    title: 'Posizioni',
    filters: {
      title: 'Filtri posizione',
      searchString: 'Nome',
      externalId: 'Identificativo',
      portfolio: 'Portafoglio',
      noPortfolio: 'Nessun portafoglio',
      otherPortfolios: 'Altri portafogli',
    },
  },

  case: {
    add: 'Crea nuova posizione',
    edit: 'Modifica posizione',
    displayName: 'Nome posizione',
    portfolio: 'Portafoglio',
    eurValue: 'Valore posizione',
    externalId: 'Identificativo',
    createPractice: 'Crea pratica',
    noPractices: 'Questa posizione non contiene ancora pratiche.',
    practices: 'Pratiche',
    tabs: {
      practices: 'Pratiche',
      events: 'Eventi',
      records: 'Schede',
      subjects: 'Soggetti',
    },
    steps: {
      case: 'Posizione',
      practice: 'Prima pratica',
      userAssignments: 'Utenti assegnati',
    },
    practiceTree: {
      legend: 'Legenda',
      parent: 'Pratica genitore',
      merge: 'Pratica riunita',
    },
  },

  practiceDetails: {
    caseTitle: 'Posizione: {name}',
    title: '{type} / {name}',
    practices: 'Pratiche',
    details: 'Dettagli',
    practiceType: 'Tipo di pratica',
    currentPhase: 'Fase corrente',
    createdAt: 'Data di registrazione',
    externalId: 'ID esterno',
    archiveNumber: 'Posizione archivio',
    eurValue: 'Valore pratica',
    eurValueOverride: 'Valore pratica sovrascritto',
    eurValueOverrideTooltip:
      'Valore impostato manualmente per questa pratica, sovrascrivendo il valore della posizione di {caseValue}',
    eurValueOverrideEditTooltip:
      'Impostando un valore qui, verrà sovrascritto il valore della posizione di {caseValue} per questa pratica.',
    judicialData: 'Riferimenti giudiziali',
    assignedUsers: 'Utenti assegnati',
    starredSubjects: 'Soggetti in evidenza',
    noStarredSubjects: 'Non ci sono soggetti in evidenza',
    tabs: {
      events: 'Eventi',
      records: 'Schede',
      subjects: 'Soggetti',
      pctEvents: 'Eventi PCT',
      tasks: 'Incarichi',
    },
    noPracticeSelected: {
      title: 'Nessuna pratica selezionata',
      body: 'Seleziona una pratica dal grafico a lato',
    },
    editPhase: 'Modifica fase pratica',
    cancelRemainingDeadlines: 'Annulla tutte le scadenze residue',
    editAssignments: 'Modifica utenti assegnati',
    editStarredSubjects: 'Modifica soggetti in evidenza',
    subject: 'Soggetto',
    unassignedPractice: 'Pratica senza utenti assegnati.',
    newAssignment: {
      user: 'Utente',
      role: 'Ruolo',
      defaultDeadlineAssignmentTooltip:
        "Indica se l'utente verrà selezionato come assegnatario alla creazione di una nuova scadenza",
    },
    deleteAssignmentWithDeadlines: {
      header: 'Scadenze assegnate',
      message:
        "L'utente {user} ha scadenze assegnate non ancora completate. Rimuovendolo dalla pratica, le scadenze potrebbero rimanere senza un responsabile. Vuoi procedere?",
    },
    massiveEmails: 'E-mail massive',
    noMassiveEmails: 'Non ci sono e-mail massive che includono questa pratica',
    noMassiveEmailResponses: 'Non sono state registrate risposte da:',
    deadlines: 'Scadenze',
    noDeadlines: 'Non ci sono scadenze per questa pratica',
    generateArchiveNumber: 'Genera',
    edit: 'Modifica pratica',
    editTabs: {
      data: 'Dati',
      relations: 'Relazioni',
      case: 'Posizione',
    },
    parentDescription:
      'Collega pratiche connesse in modo gerarchico o procedurale, che rappresentano sotto-procedimenti o fasi successive di una causa, come opposizioni, ricorsi o riconteggi.',
    mergedIntoDescription:
      "Indica che questa pratica è stata unita a un'altra. La pratica originale è estinta, ma tutte le operazioni della pratica principale si applicano anche a quella riunita.",
    selectParent: 'Seleziona pratica genitore',
    selectMergedInto: 'Seleziona pratica riunita',
    relationsPreview: 'Anteprima',
    editCase: {
      case: 'Posizione',
      caseDescription:
        'La posizione rappresenta un raccoglitore di pratiche che appartengono allo stesso caso o contesto. Tutte le relazioni tra le pratiche, come quelle di tipo "padre-figlio" o "riunita in", si applicano all\'interno della stessa posizione, consentendo di gestire in modo organizzato le pratiche collegate.',
      newCase: 'Crea una nuova posizione',
      newCaseDescription:
        'Verrà creata una nuova posizione contenente solo questa pratica; il nome della posizione sarà il nome della pratica.',
      caseEmpty:
        "Trasferendo l'unica pratica ad una posizione diversa, quella attuale resterà vuota e non verrà eliminata.",
      confirmHeader: 'Conferma trasferimento',
      confirmMessage: 'Sei sicuro di voler trasferire la pratica "{practiceName}" nella posizione "{caseName}"?',
    },
    documents: 'Documenti',
  },

  records: {
    createdBy: 'Inseriti da',
    unknown: 'Sconosciuto',
    runTools: 'Esegui tools',
    placeholders: {
      string: 'Inserisci un valore testuale',
      number: 'Inserisci un valore numerico decimale',
      int: 'Inserisci un valore numerico intero',
      eur_currency: 'Inserisci un importo (€)',
      boolean: 'boolean',
      enum: 'Scegli un valore',
      date: 'Inserisci data',
      datetime: 'Inserisci data e ora',
    },
    toolRunner: {
      title: 'Esegui tool',
      run: 'Esegui',
      unavailable: 'Non disponibile',
    },
    newValue: 'Valore',
    add: 'Aggiungi nuova scheda',
    noRecords: 'Non è stata inserita alcuna scheda',
    addSteps: {
      recordType: 'Tipo di scheda',
      payload: 'Contenuto',
    },
    recordType: 'Tipo di scheda',
    snapshots: 'Storico - {typeName}',
    edit: 'Modifica {typeName}',
    editConfirm: 'Conferma modifica',
    editConfirmDescription:
      'Quali dei seguenti tool associati al tipo di pratica vuoi eseguire dopo la modifica della scheda?',
    addDeadline: 'Aggiungi scadenza sulla data',
    starredTitle: 'Campi in evidenza',
  },

  practiceEvents: {
    eventType: 'Tipo di evento',
    createdBy: 'Creato da',
    eventPayload: 'Dati evento',
    displayName: 'Nome',
    eurValueOverride: 'Valore pratica sovrascritto',
    archiveNumber: 'Posizione archivio',
    externalId: 'ID esterno',
    parent: 'Genitore',
    mergedInto: 'Riunita in',
    case: 'Posizione',
    unknown: 'Sconosciuto',
    type: {
      AssignmentAdd: 'Assegnamento aggiunto',
      AssignmentRemove: 'Assegnamento rimosso',
      GenericEdit: 'Modifica generica',
      JudicialDataEdit: 'Modifica riferimenti giudiziali',
      SubjectAdd: 'Soggetto aggiunto',
      SubjectEdit: 'Soggetto modificato',
      SubjectRemove: 'Soggetto rimosso',
      SubjectRestore: 'Soggetto ripristinato',
      SubjectTransferToCase: 'Soggetto trasferito a posizione',
      PhaseTransition: 'Cambio fase',
      DeadlineCreation: 'Creazione scadenza',
      DeadlineCancel: 'Annullamento scadenza',
      DeadlineFullfill: 'Completamento scadenza',
      DeadlineEdit: 'Modifica scadenza',
    },
    typeResource: {
      AssignmentAdd: 'Assegnamento',
      AssignmentRemove: 'Assegnamento',
      GenericEdit: 'Modifica',
      JudicialDataEdit: 'Riferimenti giudiziali',
      SubjectAdd: 'Soggetto',
      SubjectEdit: 'Soggetto',
      SubjectRemove: 'Soggetto',
      SubjectRestore: 'Soggetto',
      SubjectTransferToCase: 'Soggetto',
      PhaseTransition: 'Cambio fase',
      DeadlineCreation: 'Scadenza',
      DeadlineCancel: 'Scadenza',
      DeadlineFullfill: 'Scadenza',
      DeadlineEdit: 'Scadenza',
    },
  },

  caseEvents: {
    eventType: 'Tipo di evento',
    createdBy: 'Creato da',
    eventPayload: 'Dati evento',
    displayName: 'Nome',
    eurValue: 'Valore posizione',
    externalId: 'Identificativo',
    portfolio: 'Portafoglio',
    practice: 'Pratica',
    unknown: 'Sconosciuto',
    type: {
      GenericEdit: 'Modifica',
      PortfolioChange: 'Cambio portafoglio',
      PracticeAdd: 'Pratica aggiunta',
      PracticeRemove: 'Pratica rimossa',
      SubjectAdd: 'Soggetto aggiunto',
      SubjectEdit: 'Soggetto modificato',
      SubjectRemove: 'Soggetto rimosso',
      SubjectRestore: 'Soggetto ripristinato',
    },
    typeResource: {
      GenericEdit: 'Modifica',
      PortfolioChange: 'Portafoglio',
      PracticeAdd: 'Pratica',
      PracticeRemove: 'Pratica',
      SubjectAdd: 'Soggetto',
      SubjectEdit: 'Soggetto',
      SubjectRemove: 'Soggetto',
      SubjectRestore: 'Soggetto',
    },
  },

  subjects: {
    noSubjects: 'Non ci sono soggetti coinvolti',
    caseSubject: 'Soggetto di posizione',
    detailsTitle: 'Soggetto',
    type: 'Tipo',
    judicial: 'Giudiziale',
    contacts: 'Contatti',
    address: 'Indirizzo',
    email: 'E-mail',
    pec: 'PEC',
    telephone: 'Telefono',
    add: 'Crea nuovo soggetto',
    edit: 'Modifica soggetto',
    records: 'Schede',
    creationSteps: {
      person: 'Persona',
      additionalData: 'Dati aggiuntivi',
    },
    remove: {
      button: 'Rimuovi',
      title: 'Conferma rimozione soggetto',
      message: 'Sei sicuro di voler rimuovere {displayName} dai soggetti coinvolti?',
    },
    transferToCase: {
      info: 'Questo soggetto è per la sola pratica corrente. Se vuoi collegarlo alla posizione e a tutte le pratiche al suo interno, puoi trasferirlo alla posizione.',
      button: 'Trasferisci in posizione',
      title: 'Trasferisci soggetto in posizione',
      message: 'Vuoi trasferire {displayName} in una posizione? Questo legherà il soggetto alla posizione.',
    },
  },

  deadlines: {
    type: 'Tipo',
    displayName: 'Nome',
    description: 'Descrizione',
    duration: 'Durata',
    actualDate: 'Data effettiva',
    createMsEvent: 'Crea evento su Microsoft Calendar',
    dueDate: 'Termine massimo',
    dueTypes: {
      Absolute: 'Assoluto',
      Relative: 'Relativo',
    },
    absoluteDueSection: 'Termine massimo assoluto',
    relativeDueSection: 'Termine massimo relativo',
    dueType: 'Tipo termine massimo',
    dueInterval: 'Intervallo',
    dueIntervalUom: 'Unità di misura',
    dueIntervalFrom: 'Da',
    dueIntervalTimeOverride: 'Sovrascrivi orario',
    fullfilledAt: 'Completata il',
    fullfilledBy: 'Completata da',
    canceledAt: 'Annullata il',
    canceledBy: 'Annullata da',
    users: 'Utenti',
    noUsers: 'Non ci sono utenti assegnati a questa scadenza',
    relativeDue: '{interval} {uom} da {relativeDeadline}',
    computedDueDateTooltip: 'Scadenza originale: {date}',
    fullfill: 'Concludi',
    fullfillDialog: {
      title: 'Conferma conclusione',
      message: 'Confermi che questa scadenza è stata adempiuta?',
      transitionPhase: 'Cambia fase',
    },
    cancel: 'Cancella',
    cancelConfirm: {
      title: 'Conferma annullamento',
      message: 'Confermi che questa scadenza è da annullare?',
    },
    editActualDate: 'Imposta data effettiva',
    msEvent: {
      true: 'Sincronizzato con Microsoft Calendar',
      false: 'Non sincronizzato con Microsoft Calendar',
    },
    reminder: 'Promemoria',
    add: 'Crea nuova scadenza',
    edit: 'Modifica scadenza',
    practice: 'Pratica',
    assignUser: {
      title: 'Aggiungi utente a scadenza',
      user: 'Utente',
      practiceAssigned: 'Utenti assegnati alla pratica',
      others: 'Altri utenti',
    },
    deassignUser: {
      title: 'Rimuovi utente',
      message: 'Sei sicuro di voler rimuovere {user} da questa scadenza?',
    },
    columns: {
      label: 'Scadenza',
      date: 'Data di scadenza',
      practice: 'Pratica',
      users: 'Utenti',
    },
    filters: {
      title: 'Filtri scadenze',
      searchString: 'Nome',
      type: 'Tipo scadenza',
      status: 'Stato',
      users: 'Utenti',
      badge: 'Badge',
      mine: 'Assegnata a me',
      unassigned: 'Non assegnata',
      assignment: 'Assegnamento',
      others: 'Altri',
      statuses: {
        unfulfilled: 'Non completata',
        fulfilled: 'Completata',
        canceled: 'Annullata',
      },
    },
    badge: 'Badge',
    badgeEditDialog: {
      title: 'Modifica badge scadenza',
    },
    badges: {
      title: 'Badge scadenze',
      displayName: 'Nome',
      color: 'Colore',
      visible: 'Visibile',
      add: 'Crea nuovo badge scadenza',
      edit: 'Modifica badge scadenza',
    },
  },

  pctEvents: {
    description: 'Descrizione',
    registry: 'Cancelleria',
    registryNote: 'Nota di cancelleria',
    details: {
      documents: 'Documenti',
      attachments: 'Allegati',
      title: 'Evento PCT',
      description: 'Descrizione',
      date: 'Data creazione',
      syncDate: 'Data sincronizzazione',
    },
    errors: {
      title: 'Errore sincronizzazione',
      outOfSync: 'La pratica non è stata sincronizzata con il PCT',
      syncError: 'Si è verificato un errore durante la sincronizzazione con il PCT',
    },
  },

  taskTypes: {
    title: 'Tipi di incarico',
    add: 'Crea nuovo tipo di incarico',
    edit: 'Modifica tipo di incarico',
    name: 'Nome',
    visible: 'Visibile',
  },

  tasks: {
    title: 'Incarichi',
    add: 'Nuovo incarico',
    edit: 'Modifica incarico',
    type: 'Tipo di incarico',
    text: 'Testo',
    assignee: 'Assegnatario',
    expiration: 'Data di scadenza',
    fulfill: 'Completa',
    cancel: 'Revoca',
    noPractice: 'Nessuna pratica associata',
    filters: {
      title: 'Filtri incarichi',
      status: 'Stato',
      assignment: 'Assegnamento',
      type: 'Tipo',
      unassigned: 'Non assegnati',
      mine: 'Miei',
      others: 'Altri',
      statuses: {
        pending: 'Da fare',
        fulfilled: 'Completati',
        canceled: 'Annullati',
      },
    },
    status: {
      pending: 'Da fare',
      fulfilled: 'Completato',
      canceled: 'Revocato',
    },
    column: {
      task: 'Incarico',
      expiration: 'Scadenza',
      status: 'Stato',
      type: 'Tipo',
      practice: 'Pratica',
      assignee: 'Assegnatario',
      fulfilledAt: 'Completato',
      canceledAt: 'Annullato',
    },
    details: {
      text: 'Testo',
      expiration: 'Data di scadenza',
      practice: 'Pratica',
      assignee: 'Assegnatario',
      events: 'Eventi',
      createdBy: 'Creato da',
      fulfilledBy: 'Completato da',
      canceledBy: 'Annullato da',
    },
    fulfillDialog: {
      title: 'Conferma completamento',
      message: 'Sei sicuro di voler contrassegnare questo incarico come completato?',
    },
    cancelDialog: {
      title: 'Conferma annullamento',
      message: 'Sei sicuro di voler contrassegnare questo incarico come annullato?',
    },
    clickToAssign: 'Clicca per assegnare',
    assignDialog: {
      title: 'Assegna incarico',
    },
  },

  subjectTypes: {
    title: 'Tipi di soggetti',
    add: 'Crea nuovo tipo di soggetto',
    edit: 'Modifica tipo di soggetto',
    displayName: 'Nome',
    color: 'Colore',
    visible: 'Visibile',
    section: 'Sezione',
    detailsTitle: 'Tipo soggetto',
    recordsTitle: 'Tipi di Scheda',
  },

  recordTypes: {
    title: 'Tipi di schede',
    caseRecordTypes: 'Tipi schede posizione',
    add: 'Crea nuovo tipo di scheda',
    edit: 'Modifica tipo di scheda',
    displayName: 'Nome',
    tabular: 'Tabellare',
    readRoles: 'Ruoli in lettura',
    writeRoles: 'Ruoli in scrittura',
    detailsTitle: 'Tipo scheda',
    fieldsTitle: 'Campi specifici',
    sortFields: 'Riordina campi specifici',
    rolesDialog: {
      readTitle: 'Modifica ruoli in lettura',
      writeTitle: 'Modifica ruoli in scrittura',
      role: 'Ruolo',
      noRoles: 'Non ci sono ruoli configurati',
    },
  },

  assignedRecordTypes: {
    title: 'Tipi di scheda',
    recordType: 'Tipo di scheda',
    add: 'Aggiungi nuova scheda',
    removeHeader: 'Rimozione',
    removeMessage: 'Sei sicuro di voler rimuovere "{displayName}" dalle schede?',
    sort: 'Riordina',
    sortTitle: 'Riordina tipi di schede',
  },

  persons: {
    title: 'Persone',
    displayName: 'Denominazione',
    fiscalCode: 'Codice fiscale',
    vatCode: 'Partita IVA',
    email: 'E-mail',
    pec: 'PEC',
    telephone: 'Telefono',
    externalId: 'ID esterno',
    type: {
      Physical: 'Fisica',
      Legal: 'Giuridica',
    },
    filters: {
      title: 'Filtri persona',
      searchString: 'Nome, e-mail o codice fiscale',
      externalId: 'ID esterno',
      type: 'Tipo',
      pctLawyer: 'Avvocato',
    },
    add: 'Crea nuova persona',
    edit: 'Modifica persona',
    mergeDialog: {
      title: 'Riunione duplicati',
      description:
        'Stai per riunire questa persona con quella che selezionerai dalla lista sottostante. Questa sarà eliminata e tutte le sue occorrenze nelle pratiche saranno rimpiazzate con la nuova persona.',
      confirmMessage:
        'Stai riunendo {duplicateName} con {targetName}. Sei sicuro di voler procedere? Questa azione è irreversibile.',
      confirmTitle: 'Conferma riunione',
      button: 'Riunione duplicati',
    },
  },

  personDetails: {
    person: 'Persona',
    linkedPersons: 'Persone collegate',
    linkedCompanies: 'Aziende collegate',
    subjects: 'Appare in:',
    type: 'Tipo',
    pctLawyer: 'Avvocato',
    legalNature: 'Natura legale',
    legalNatureTooltip:
      "Indica la forma giuridica con cui un ente, un'organizzazione o una persona opera secondo la legge",
    displayName: 'Denominazione',
    title: 'Titolo',
    pctLawyerTooltip: 'Le persone con questo flag possono essere inserite nei depositi con ruolo di avvocato.',
    firstName: 'Nome',
    lastName: 'Cognome',
    createdAt: 'Data registrazione',
    externalId: 'ID esterno',
    fiscalCode: 'Codice fiscale',
    contacts: 'Contatti',
    address: 'Indirizzo',
    street: 'Via',
    houseNumber: 'Nr.',
    city: 'Città',
    province: 'Provincia',
    postalCode: 'CAP',
    country: 'Nazione',
    birthDate: 'Data di nascita',
    birthPlace: 'Luogo di nascita',
    vatCode: 'Partita IVA',
    paCode: 'Codice univoco PA',
    email: 'E-mail',
    pec: 'PEC',
    telephone: 'Telefono',
    noSubjects: 'Questa persona non appare in alcun soggetto',
    noAssignedSubjects: 'Questa persona non appare in alcun soggetto a te assegnato',
    links: {
      add: 'Aggiungi persona collegata',
      noLinks: 'Questa persona non ha collegamenti',
      removeConfirmTitle: 'Conferma rimozione',
      removeConfirmMessage: 'Sei sicuro di voler rimuovere {displayName} dalle persone collegate?',
    },
  },

  reports: {
    title: 'Report',
    download: 'Download',
    add: 'Genera nuovo report',
    type: 'Tipo',
    format: 'Formato',
  },

  massiveEmailTypes: {
    title: 'Tipi e-mail massive',
    displayName: 'Nome',
    color: 'Colore',
    add: 'Crea nuovo tipo di e-mail massiva',
    edit: 'Modifica tipo di e-mail massiva',
  },

  massiveEmails: {
    title: 'E-mail massive',
    send: 'Invia',
    close: 'Termina',
    alreadySent: "L'e-mail è già stata inviata",
    sendDialog: {
      title: 'Conferma invio',
      message: 'Sei sicuro di voler procedere all\'invio dell\'email massive "{name}"?',
    },
    closeDialog: {
      title: 'Conferma chiusura',
      message:
        'Sei sicuro di voler terminare l\'e-mail massiva "{name}"? Le risposte successive non saranno registrate.',
    },
    phase: {
      draft: 'Bozza',
      sent: 'Inviata',
      closed: 'Terminata',
    },
    add: 'Crea nuova e-mail massiva',
    edit: 'Modifica e-mail massiva',
  },

  toolRuns: {
    title: 'Esecuzioni tools',
    toolKey: 'Chiave',
    toolVersion: 'Versione',
    eurPrice: 'Prezzo',
    lastUpdate: 'Ultimo aggiornamento',
    add: 'Crea nuova esecuzione tool',
    edit: 'Modifica esecuzione tool',
    detailsTitle: 'Esecuzione tool',
    input: 'Input',
    output: 'Output',
    execute: 'Esegui',
    status: {
      success: 'Successo',
      error: 'Errore',
      running: 'In esecuzione',
      draft: 'Bozza',
    },
    confirmExecution: {
      title: 'Conferma esecuzione',
      message:
        "Sei sicuro di voler eseguire il tool {toolKey}? Ha un costo di {eurPrice} e l'esecuzione potrebbe richiedere del tempo.",
    },
    error: 'Errore',
    errorDetail: 'Dettaglio errore',
    errorMessage: 'Messaggio',
  },

  massiveEmailDetails: {
    type: 'Tipo',
    displayName: 'Nome',
    template: 'Template',
    redirectUrl: 'URL di reindirizzamento',
    created: 'Creata',
    sent: 'Inviata',
    closed: 'Terminata',
    tabs: {
      events: 'Eventi',
      metadata: 'Metadata',
      preview: 'Anteprima',
      receivers: 'Destinatari',
      responses: 'Risposte',
    },
    subject: 'Oggetto',
    editSubject: 'Modifica oggetto',
    metadata: {
      title: 'Metadata',
      removalTitle: 'Conferma rimozione',
      removalMessage: 'Sei sicuro di voler rimuovere "{key}" dai metadata?',
      add: 'Aggiungi metadata',
      edit: 'Modifica metadata "{key}"',
      key: 'Chiave',
      value: 'Valore',
    },
    answers: {
      title: 'Risposte',
      removalTitle: 'Conferma rimozione',
      removalMessage: 'Sei sicuro di voler rimuovere "{label}: {value}" dalle risposte?',
      add: 'Aggiungi nuova risposta',
      edit: 'Modifica risposta',
      value: 'Valore',
      label: 'Etichetta',
      extra: 'Extra',
      noExtra: 'Non sono stati impostati parametri extra',
      extraKey: 'Chiave',
      extraValue: 'Valore',
    },
    preview: {
      subject: 'Oggetto',
      body: 'Corpo',
      empty: 'Vuoto',
      rendered: 'Rendering',
    },
    responses: {
      filtersTitle: 'Filtri risposte',
      filterSearchString: 'E-mail, nome pratica o posizione archivio',
      filterResponse: 'Risposta',
    },
    stats: {
      receivers: 'Destinatari',
      responses: 'Risposte',
    },
  },

  massiveEmailReceivers: {
    add: 'Aggiungi nuovi destinatari',
    import: 'Importa destinatari',
    sourceFile: 'File sorgente (*.xlsx)',
    sourceFileDescription:
      'Il file sorgente deve contenere le colonne "practiceId" e "emailAddresses". Altre colonne saranno trattate come metadata',
    metadata: 'Metadata',
    replace: 'Sostituisci',
    replaceDescription:
      'Scegliendo l\'opzione "sostituisci", i destinatari che non sono nel file caricato saranno rimossi dalla lista',
    steps: {
      practice: 'Pratica',
      addresses: 'Indirizzi',
    },
    filters: {
      title: 'Filtri destinatari',
      searchString: 'E-mail, nome pratica o posizione archivio',
    },
    remove: {
      title: 'Conferma rimozione',
      message: 'Sei sicuro di voler rimuovere "{address}" dalla lista destinatari?',
    },
  },

  massiveImports: {
    title: 'Import massivi',
    status: {
      success: 'Successo',
      error: 'Errore',
      running: 'In esecuzione',
    },
    errorMessage: "Messaggio d'errore",
    report: 'Report',
    add: 'Nuovo import massivo',
    type: 'Tipo',
    sourceFile: 'File sorgente',
    replace: 'Sostituisci',
    practiceType: 'Tipo di pratica',
    customerFiscalCode: 'Codice fiscale cliente',
    customerSubjectType: 'Tipo soggetto cliente',
    customerManagerSubjectType: 'Tipo soggetto gestore cliente',
    debtorSubjectType: 'Tipo soggetto debitore',
    lawyerSubjectType: 'Tipo soggetto avvocato',
    subjectType: 'Tipo Soggetto',
    recordType: 'Tipo scheda',
    recordFieldKey: 'Campo scheda',
    minDate: 'Data minima',
  },

  pct: {
    title: 'Polisweb',
    notFound: 'Pratica non trovata nel Polisweb',
    notPermitted:
      'La pratica non può essere scaricata dal Polisweb.\nCodice errore: {errorCode}\nMessaggio errore: {errorMessage}',
    error: 'Si è verificato un errore durante il tentativo di scaricare la pratica dal Polisweb.',
  },

  pctDeposits: {
    title: 'Depositi PCT',
    add: {
      title: 'Nuovo deposito',
      type: 'Tipo',
      urgent: 'Urgente',
      court: 'Tribunale',
      registry: 'Registro',
      generalRoleNumber: 'Numero di ruolo generale',
      externalDeposit: 'Deposito esterno',
      externalNote: 'Se la tipologia di deposito non è ancora supportata puoi utilizzare un software esterno.',
    },
    editUrgent: 'Modifica urgenza',
    editReferenceText: 'Modifica riferimenti',
    editDemand: 'Modifica domanda',
    editNotes: 'Modifica note',
    editNominaConsulente: 'Modifica nomina consulente',
    editInstances: 'Modifica istanze',
    editDevices: 'Modifica dispositivi',
    editPartyFiscalCode: 'Modifica codice fiscale parte',
    partyFiscalCode: 'Codice fiscale parte',
    notes: 'Note',
    referenceText: 'Riferimento',
    demand: 'Domanda',
    device: 'Dispositivo',
    instances: 'Istanze',
    otherInstances: '+{count} altre istanze',
    notaSpese: {
      compensi: 'Compensi',
      speseEsenti: 'Spese esenti',
      speseGenerali: 'Spese generali',
      speseImponibili: 'Spese imponibili',
    },
    ricusazioneCtu: {
      ctuCodiceFiscale: 'Codice Fiscale CTU',
    },
    type: 'Tipo',
    status: 'Stato',
    user: 'Utente',
    court: 'Tribunale',
    pecId: 'ID PEC',
    filters: {
      title: 'Filtri depositi',
    },
    generalRoleNumber: 'Numero di ruolo generale',
    judicialData: 'Riferimenti giudiziali',
    practice: 'Pratica',
    createdAt: 'Data di creazione',
    sentAt: 'Data di invio',
    statuses: {
      draft: 'Bozza',
      sent: 'Inviato',
      locked: 'Bloccato',
    },
    detailsTitle: 'Deposito PCT [{pecId}]',
    parties: {
      title: 'Modifica anagrafiche',
      personDetails: 'Dettagli persona',
      fiscalCode: 'Codice fiscale',
      fiscalCodeMessage: 'Il codice fiscale è obbligatorio',
      role: 'Ruolo',
      deleteTitle: 'Conferma eliminazione',
      deleteMessage: 'Sei sicuro di voler eliminare {displayName} dal deposito?',
      represents: 'Rappresenta',
    },
    partyCreationSteps: {
      role: 'Ruolo',
      person: 'Persona',
      additionalData: 'Dati aggiuntivi',
    },
    partyRoles: {
      Parte: 'Parte',
      Chiamato: 'Chiamato',
      Avvocato: 'Avvocato',
      Consulente: 'Consulente',
    },
    representedParties: 'Parti rappresentate',
    consultantNomination: 'Nomina Consulente',
    delete: {
      title: 'Conferma eliminazione',
      message: 'Sei sicuro di voler eliminare questo deposito?',
    },
    attachments: {
      title: 'Allegati',
      add: 'Aggiungi nuovo allegato',
      addSignatureWarning:
        "Attenzione: se l'allegato non è firmato, verrà automaticamente firmato durante il processo di caricamento.",
      delete: {
        title: 'Conferma eliminazione',
        message: 'Sei sicuro di voler eliminare l\'allegato "{name}"?',
      },
      addErrors: {
        duplicateMain: 'Può esserci solo un allegato principale',
        duplicateFilename: 'Esiste già un allegato con lo stesso nome',
        mainNotSigned: "L'allegato principale deve essere un PDF firmato",
        resourceNotSigned: 'Questo tipo di allegato deve essere firmato',
        generic: "Si è verificato un errore durante il caricamento dell'allegato",
      },
      signErrors: {
        generic: "Si è verificato un errore durante la firma dell'allegato",
        alreadyRunning: "L'allegato è già in fase di firma, attendere prego",
      },
      sign: {
        title: 'Firma allegato',
        message: 'Sei sicuro di voler firmare l\'allegato "{name}"?',
      },
      main: 'Allegato principale',
      datiAtto: 'File di struttura',
      notMain: 'Altro',
      signed: 'Firmato',
      inputLabel: 'Seleziona un file da caricare',
      downloadDatiAtto: 'Scarica DatiAtto.xml',
      generateSignedDatiAtto: 'Genera DatiAtto.xml firmato',
      contextMenu: {
        view: 'Visualizza',
        download: 'Scarica',
        delete: 'Elimina',
        sign: 'Firma',
      },
    },
    checks: {
      title: 'Controlli',
      outcome: 'Esito',
      types: {
        Acceptance: 'Accettazione',
        AutomaticChecks: 'Controlli automatici',
        PecAcceptance: 'Accettazione PEC',
        PecDelivery: 'Consegna PEC',
      },
    },
    send: {
      button: 'Invia',
      confirmTitle: 'Conferma invio',
      confirmMessage: 'Sei sicuro di voler inviare il deposito a {court} con numero {rg}?',
    },
  },

  apbPractices: {
    title: 'Pratiche APB',
    practiceName: 'Nome',
    practiceCourt: 'Tribunale',
    practiceRegistrationNumber: 'RG',
    operatorsEmail: 'E-mail',
    practiceExternalId: 'ID esterno',
    filters: {
      title: 'Filtri pratiche',
      name: 'Nome',
      court: 'Tribunale',
      registrationNumber: 'RG',
      externalId: 'ID esterno',
      operatorsEmail: 'E-mail',
    },
  },

  apbProcessedEmails: {
    title: 'E-mail elaborate APB',
    detailsTitle: 'E-mail APB',
    sender: 'Mittente',
    subject: 'Oggetto',
    date: 'Ricevuta',
    processedAt: 'Elaborata',
    forwarded: 'Inoltrata',
    forwardedTo: 'Inoltrata a',
    detection: 'Rilevamento',
    tag: 'Tag',
    tags: {
      Closeout: 'Chiusura',
      Outcome: 'Esito',
      Mediation: 'Mediazione',
      Other: 'Altro',
      TooBig: 'Troppo grande',
    },
    filters: {
      title: 'Filtri e-mail',
      sender: 'Mittente',
      subject: 'Oggetto',
      forwardedTo: 'Inoltrata a',
      tag: 'Tag',
    },
    unknownUser: 'Sconosciuto',
    newProcessing: {
      title: 'Nuova elaborazione',
      button: 'Nuova elaborazione',
      description: 'Questa procedura consente di elaborare le e-mail che non sono state elaborate nel giorno indicato',
      onlyOnDate: 'Data',
    },
  },

  errorFallbackDefault: {
    title: 'Oops! Qualcosa è andato storto.',
    message:
      'Ci dispiace, si è verificato un errore durante il caricamento della pagina. Si prega di riprovare più tardi.',
    button: 'Ricarica la pagina',
  },

  errorServer: {
    title: 'Oops! Si è verificato un errore al server!',
    message: 'Per qualsiasi evenienza contatta {email}',
    button: 'Ricarica la pagina',
  },

  errorFallbackUnauthorized: {
    title: 'Accesso Negato',
    message: 'Spiacenti, non sei autorizzato ad accedere a questa pagina o la tua sessione è scaduta.',
    messageSecondary: 'Verrai reindirizzato automaticamente alla pagina di login in {seconds} secondi.',
    button: 'Vai alla pagina di login',
  },

  notFound: {
    code: '{code}',
    message: 'Oops! La pagina che stai cercando non esiste.',
    button: 'Vai alla Home',
  },

  profile: {
    title: 'Profilo personale',
    personalSettings: 'Impostazioni personali',
    locale: 'Lingua',
    locales: {
      'it-IT': 'Italiano',
      'en-US': 'Inglese',
    },
  },

  passwordChange: {
    passwordChange: 'Cambio password',
    oldPassword: 'Vecchia password',
    newPassword: 'Nuova password',
    passwordChanged: 'Password modificata!',
  },

  passwordStrength: {
    empty: 'Digita password',
    weak: 'Debole',
    medium: 'Media',
    strong: 'Robusta',
  },

  firstPasswordChange: {
    title: 'Imposta una nuova password',
    body: "Benvenuto! La password che hai utilizzato ti è stata fornita dall'amministratore per il primo accesso al sistema.\nPer motivi di sicurezza, ti invitiamo a impostare una nuova password per i futuri accessi. Potrai sempre cambiarla in seguito dalla pagina del profilo.",
  },

  /* cspell:ignore BRZJJA,Vetere,DIOAI,Dott. */
  placeholders: {
    address: 'Via Roma, 1, 30100 Verona VR, Italia',
    answerExtraKey: 'descrizione',
    answerExtraValue: 'Certo che vorrei accettare!',
    answerLabel: 'Sì',
    answerValue: '1',
    archiveNumber: '123-123',
    choose: 'Scegli',
    city: 'Verona',
    country: 'Italia',
    courts: 'Santa Maria Capua Vetere',
    deadline: 'Scadenza',
    deadlineTypeCategory: 'Udienza, adempimento, altro',
    description: 'Descrizione...',
    displayName: 'James Bond',
    duration: 'hh:mm',
    email: "{'nomeutente@dominio.it'}",
    eurValue: '100,00',
    externalId: '1234',
    externalIdLabel: 'ID cliente',
    fieldDisplayName: 'Valore proposto',
    fieldKey: 'valore_proposto',
    firstName: 'James',
    fiscalCode: 'BRZJJA24M22G722E',
    generalRoleNumber: '1234/2024',
    houseNumber: '10',
    lastName: 'Bond',
    metadataKey: 'intro_1',
    metadataValue: 'Gentile collega...',
    officeCode: '1234567890',
    pec: "{'nomeutentepec@dominiopec.it'}",
    personTitle: 'Dott.',
    phaseName: 'Studio',
    postalCode: '30100',
    practiceDisplayName: 'Alma Iura contro James Bond',
    practiceType: 'Mediazione',
    province: 'VR',
    recordType: 'Contratto',
    roleDescription: 'Dettaglio...',
    roleName: 'Amministratore',
    roleSelect: 'Seleziona un ruolo',
    search: 'Cerca',
    section: 'Sezione A',
    settingVariableName: 'JWT_SECRET_2',
    settingVariableValue: 'ygKm0ZdDIOAI2',
    street: 'Via Roma',
    subject: "Contatto per la pratica {'{{practiceName}}'}",
    subjectType: 'Debitore',
    taskText: 'Testo incarico...',
    taskType: 'Controllo atto',
    telephone: '343 444 3344',
    url: 'https://aird-web.almaiura.it',
    vatCode: 'IT11111111111',
    paCode: '16 caratteri max',
  },
}
